function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
import Vue from "vue";
import * as hooks from "@vue/composition-api";
import { t } from "@opentiny/vue-locale";
import "@opentiny/vue-theme/base/index.css";
var emitter = function emitter2() {
  var listeners = {};
  var on = function on2(event, callback, once) {
    if (once === void 0) {
      once = false;
    }
    if (event && typeof event === "string" && typeof callback === "function") {
      var callbacks = listeners[event] || [];
      listeners[event] = callbacks;
      callbacks.push(callback);
      callback.once = once;
    }
  };
  var emitter22 = {
    emit: function emit(eventName) {
      var _arguments = arguments;
      var callbacks = listeners[eventName];
      if (callbacks) {
        callbacks.forEach(function(callback) {
          return callback.apply(null, [].slice.call(_arguments, 1));
        });
        listeners[eventName] = callbacks.filter(function(callback) {
          return !callback.once;
        });
      }
    },
    on,
    once: function once(event, callback) {
      on(event, callback, true);
    },
    off: function off(event, callback) {
      if (event && typeof event === "string") {
        var callbacks = listeners[event];
        if (typeof callback === "function") {
          listeners[event] = callbacks.filter(function(cb) {
            return cb !== callback;
          });
        } else {
          delete listeners[event];
        }
      } else {
        listeners = {};
      }
    }
  };
  return emitter22;
};
var bindFilter = function bindFilter2(props2, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  var properties = {};
  for (var name in props2) {
    if (name.indexOf("_") !== 0) {
      properties[name] = props2[name];
    }
  }
  for (var _name in attrs) {
    properties[_name] = attrs[_name];
  }
  return properties;
};
var getElementStatusClass = function getElementStatusClass2(className, status) {
  if (!className || !status)
    return;
  var classNames = [];
  if (typeof className === "string") {
    classNames.push(className);
  } else if (Array.isArray(className)) {
    classNames = className;
  }
  var statusList = [];
  if (typeof status === "string") {
    statusList.push(status);
  } else if (Array.isArray(status)) {
    statusList = status;
  }
  var res = [];
  statusList.forEach(function(status2) {
    return classNames.forEach(function(name) {
      return res.push(status2 + ":" + name + "-" + status2);
    });
  });
  return classNames.concat(res).join(" ");
};
var getElementCssClass = function getElementCssClass2(classes, key) {
  if (classes === void 0) {
    classes = {};
  }
  if (typeof key === "object") {
    var keys = Object.keys(key);
    var cls = "";
    keys.forEach(function(k) {
      if (key[k] && classes[k])
        cls += classes[k] + " ";
    });
    return cls;
  } else {
    return classes[key] || "";
  }
};
var globalId = 0;
var getHasComment = function getHasComment2(state) {
  return function(comment) {
    var childNodes = Array.from(state.parent.childNodes);
    for (var i = 0; i < childNodes.length; i++) {
      if (childNodes[i].textContent === comment) {
        return true;
      }
    }
  };
};
var getGetFragment = function getGetFragment2(_ref6) {
  var hasComment = _ref6.hasComment, startComment = _ref6.startComment, state = _ref6.state, endComment = _ref6.endComment;
  return function(commentFlag) {
    var fragment = document.createDocumentFragment();
    commentFlag && !hasComment(startComment) && fragment.appendChild(document.createComment(startComment));
    state.nodes.forEach(function(node) {
      return fragment.appendChild(node);
    });
    commentFlag && !hasComment(endComment) && fragment.appendChild(document.createComment(endComment));
    return fragment;
  };
};
var getDisable = function getDisable2(_ref7) {
  var instance = _ref7.instance, getFragment = _ref7.getFragment, state = _ref7.state, startComment = _ref7.startComment, endComment = _ref7.endComment;
  return function() {
    instance.$el.appendChild(getFragment());
    var indices = [];
    Array.from(state.parent.childNodes).forEach(function(child, i) {
      if (child.nodeType === 8) {
        if (child.textContent === startComment || child.textContent === endComment) {
          indices.push(i);
        }
      }
    });
    var minIndex = Math.min.apply(Math, indices);
    var maxIndex = Math.max.apply(Math, indices);
    Array.from(state.parent.childNodes).slice(minIndex, maxIndex + 1).reverse().forEach(function(child) {
      return state.parent.removeChild(child);
    });
    state.parent = null;
  };
};
var getMove = function getMove2(_ref8) {
  var state = _ref8.state, props2 = _ref8.props, disable = _ref8.disable, getFragment = _ref8.getFragment;
  return function() {
    state.waiting = false;
    state.parent = document.querySelector(props2.to);
    if (!state.parent) {
      disable();
      state.waiting = true;
      return;
    }
    if (props2.where === "before") {
      state.parent.prepend(getFragment(true));
    } else {
      state.parent.appendChild(getFragment(true));
    }
  };
};
var getTeardownObserver = function getTeardownObserver2(state) {
  return function() {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
  };
};
var getOnMutations = function getOnMutations2(_ref9) {
  var state = _ref9.state, disable = _ref9.disable, props2 = _ref9.props, move = _ref9.move;
  return function(mutations) {
    var shouldMove = false;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      var filteredAddedNodes = Array.from(mutation.addedNodes).filter(function(node) {
        return !state.nodes.includes(node);
      });
      if (Array.from(mutation.removedNodes).includes(state.parent)) {
        disable();
        state.waiting = !props2.disabled;
      } else if (state.waiting && filteredAddedNodes.length > 0) {
        shouldMove = true;
      }
    }
    shouldMove && move();
  };
};
var getBootObserver = function getBootObserver2(_ref10) {
  var state = _ref10.state, onMutations = _ref10.onMutations;
  return function() {
    if (state.observer)
      return;
    state.observer = new MutationObserver(function(mutations) {
      return onMutations(mutations);
    });
    state.observer.observe(document.body, {
      attributes: false,
      characterData: false,
      childList: true,
      subtree: true
    });
  };
};
var getAfterUpdated = function getAfterUpdated2(_ref11) {
  var state = _ref11.state, instance = _ref11.instance, props2 = _ref11.props, bootObserver = _ref11.bootObserver, maybeMove = _ref11.maybeMove;
  return function() {
    state.nodes = Array.from(instance.$el.childNodes);
    !props2.disabled && bootObserver();
    maybeMove();
  };
};
var getWatchDisabled = function getWatchDisabled2(_ref12) {
  var disable = _ref12.disable, teardownObserver = _ref12.teardownObserver, bootObserver = _ref12.bootObserver, move = _ref12.move;
  return function(value) {
    if (value) {
      disable();
      teardownObserver();
      return;
    }
    bootObserver();
    move();
  };
};
var teleport = function teleport2(_ref13) {
  var reactive = _ref13.reactive, watch = _ref13.watch, getCurrentInstance = _ref13.getCurrentInstance, onUpdated = _ref13.onUpdated, onMounted = _ref13.onMounted, onBeforeUnmount = _ref13.onBeforeUnmount, h2 = _ref13.h, defineComponent2 = _ref13.defineComponent;
  return defineComponent2({
    name: "Vue2Teleport",
    props: {
      to: {
        type: String,
        required: true
      },
      where: {
        type: String,
        default: "after"
      },
      disabled: Boolean
    },
    setup: function setup3(props2) {
      var _getCurrentInstance;
      var state = reactive({
        nodes: [],
        waiting: false,
        observer: null,
        parent: null,
        id: ++globalId
      });
      var instance = (_getCurrentInstance = getCurrentInstance()) == null ? void 0 : _getCurrentInstance.proxy;
      var startComment = "[" + state.id + "]vue2-teleporter-start";
      var endComment = "[" + state.id + "]vue2-teleporter-end";
      var hasComment = getHasComment(state);
      var getFragment = getGetFragment({
        hasComment,
        startComment,
        state,
        endComment
      });
      var disable = getDisable({
        instance,
        getFragment,
        state,
        startComment,
        endComment
      });
      var move = getMove({
        state,
        props: props2,
        disable,
        getFragment
      });
      var maybeMove = function maybeMove2() {
        return !props2.disabled && move();
      };
      var teardownObserver = getTeardownObserver(state);
      var onMutations = getOnMutations({
        state,
        disable,
        props: props2,
        move
      });
      var bootObserver = getBootObserver({
        state,
        onMutations
      });
      var afterUpdated = getAfterUpdated({
        state,
        instance,
        props: props2,
        bootObserver,
        maybeMove
      });
      var watchDisabled = getWatchDisabled({
        disable,
        teardownObserver,
        bootObserver,
        move
      });
      watch(function() {
        return props2.to;
      }, maybeMove);
      watch(function() {
        return props2.where;
      }, maybeMove);
      watch(function() {
        return props2.disabled;
      }, watchDisabled);
      onUpdated(afterUpdated);
      onMounted(afterUpdated);
      onBeforeUnmount(function() {
        disable();
        teardownObserver();
      });
      return function() {
        return h2("div", {
          class: "vue2-teleporter",
          style: {
            "visibility:hidden;display:none;": !props2.disabled
          }
        }, (typeof (instance == null ? void 0 : instance.$slots.default) === "function" ? instance.$slots.default() : instance.$slots.default) || null);
      };
    }
  });
};
var Teleport = teleport(hooks);
if (!hooks.default["__composition_api_installed__"]) {
  Vue.use(hooks.default);
}
var defineAsyncComponent = function defineAsyncComponent2(_ref14) {
  var loader = _ref14.loader, loadingComponent = _ref14.loadingComponent, errorComponent = _ref14.errorComponent, delay = _ref14.delay, timeout = _ref14.timeout;
  return function() {
    return {
      component: loader(),
      loading: loadingComponent,
      error: errorComponent,
      delay,
      timeout
    };
  };
};
var markRaw = function markRaw2(ref) {
  return ref;
};
var renderComponent = function renderComponent2(_ref15) {
  var _ref15$view = _ref15.view, view = _ref15$view === void 0 ? null : _ref15$view, _ref15$component = _ref15.component, component = _ref15$component === void 0 ? null : _ref15$component, props2 = _ref15.props, _ref15$context = _ref15.context, attrs = _ref15$context.attrs, on = _ref15$context.listeners, slots = _ref15$context.slots, _ref15$extend = _ref15.extend, extend = _ref15$extend === void 0 ? {} : _ref15$extend;
  return function() {
    var _Object$assign;
    return hooks.h(view && view.value || component, Object.assign((_Object$assign = {
      props: props2,
      attrs
    }, _Object$assign[extend.isSvg ? "nativeOn" : "on"] = on, _Object$assign.scopedSlots = _extends2({}, slots), _Object$assign), extend));
  };
};
var rootConfig = function rootConfig2() {
  var _hooks$getCurrentInst;
  return (_hooks$getCurrentInst = hooks.getCurrentInstance()) == null ? void 0 : _hooks$getCurrentInst.proxy.$root;
};
var getComponentName = function getComponentName2() {
  var _instance$vnode, _instance$vnode$compo, _instance$vnode$compo2, _instance$vnode$compo3;
  var instance = hooks.getCurrentInstance();
  var componentName = instance == null ? void 0 : (_instance$vnode = instance.vnode) == null ? void 0 : (_instance$vnode$compo = _instance$vnode.componentOptions) == null ? void 0 : (_instance$vnode$compo2 = _instance$vnode$compo.Ctor) == null ? void 0 : (_instance$vnode$compo3 = _instance$vnode$compo2.extendOptions) == null ? void 0 : _instance$vnode$compo3.name;
  if (!componentName) {
    var _instance$parent, _instance$parent$vnod, _instance$parent$vnod2, _instance$parent$vnod3, _instance$parent$vnod4;
    componentName = instance == null ? void 0 : (_instance$parent = instance.parent) == null ? void 0 : (_instance$parent$vnod = _instance$parent.vnode) == null ? void 0 : (_instance$parent$vnod2 = _instance$parent$vnod.componentOptions) == null ? void 0 : (_instance$parent$vnod3 = _instance$parent$vnod2.Ctor) == null ? void 0 : (_instance$parent$vnod4 = _instance$parent$vnod3.extendOptions) == null ? void 0 : _instance$parent$vnod4.name;
  }
  return componentName || "";
};
var appContext = function appContext2() {
  return Vue;
};
var appProperties = function appProperties2() {
  return Vue.prototype;
};
var useRouter = function useRouter2(instance) {
  var _instance, _instance2;
  if (instance === void 0) {
    var _hooks$getCurrentInst2;
    instance = (_hooks$getCurrentInst2 = hooks.getCurrentInstance()) == null ? void 0 : _hooks$getCurrentInst2.proxy;
  }
  return {
    route: (_instance = instance) == null ? void 0 : _instance.$route,
    router: (_instance2 = instance) == null ? void 0 : _instance2.$router
  };
};
var emitEvent = function emitEvent2(vm) {
  var _broadcast = function broadcast(vm2, componentName, eventName, params) {
    vm2.$children.forEach(function(child) {
      var name = child.$options.componentName;
      if (name === componentName)
        child.$emit(eventName, params);
      else
        _broadcast(child, componentName, eventName, params);
    });
  };
  return {
    dispatch: function dispatch(componentName, eventName, params) {
      var _parent;
      var parent22 = vm.$parent || vm.$root;
      var name = parent22.$options.componentName;
      while (parent22 && (!name || name !== componentName)) {
        parent22 = parent22.$parent;
        if (parent22)
          name = parent22.$options.componentName;
      }
      if (parent22)
        (_parent = parent22).$emit.apply(_parent, [eventName].concat(params));
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast(vm, componentName, eventName, params);
    }
  };
};
var parent = function parent2(vm) {
  return function(handler) {
    var parent22 = vm.$parent;
    var level = 0;
    var parentObject = function parentObject2(parent3) {
      return {
        level,
        vm: createVm({}, parent3),
        el: parent3.$el,
        options: parent3.$options
      };
    };
    if (typeof handler !== "function")
      return parent22 ? parentObject(parent22) : {};
    level++;
    while (parent22) {
      if (handler(parentObject(parent22)))
        break;
      parent22 = parent22.$parent;
      level++;
    }
  };
};
var children = function children2(vm) {
  return function(handler) {
    if (typeof handler !== "function")
      return generateChildren(vm.$children);
    var layer = 1;
    var broadcast = function broadcast2($children) {
      var level = layer++;
      if ($children.some(function(child) {
        return handler({
          level,
          vm: createVm({}, child),
          el: child.$el,
          options: child.$options,
          isLevel1: level === 1
        });
      }))
        return;
      $children.forEach(function(child) {
        return broadcast2(child.$children);
      });
    };
    broadcast(vm.$children);
  };
};
var generateChildren = function generateChildren2($children) {
  var children22 = [];
  children22.refs = {};
  $children.forEach(function(child) {
    var vm = createVm({}, child);
    children22.push(vm);
    child.$vnode.data.ref && (children22.refs[child.$vnode.data.ref] = vm);
  });
  return children22;
};
var defineProperties = function defineProperties2(vm, instance, filter22) {
  var _loop = function _loop2(name2) {
    if (typeof filter22 === "function" && filter22(name2))
      return 1;
    Object.defineProperty(vm, name2, {
      configurable: true,
      enumerable: true,
      get: function get() {
        return instance[name2];
      },
      set: function set(value) {
        return instance[name2] = value;
      }
    });
  };
  for (var name in instance) {
    if (_loop(name))
      continue;
  }
  return vm;
};
var filter = function filter2(name) {
  return name.indexOf("$") === 0 || name.indexOf("_") === 0 || name === "constructor";
};
var customEmit = function customEmit2(context, emit) {
  return function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    emit.apply(context, args);
    if (args[0] === "update:modelValue")
      emit.apply(context, ["input"].concat(args.slice(1)));
  };
};
var createVm = function createVm2(vm, instance, context) {
  if (context === void 0) {
    context = void 0;
  }
  context || defineProperties(vm, instance, filter);
  Object.defineProperties(vm, {
    $attrs: {
      get: function get() {
        return instance.$attrs;
      }
    },
    $children: {
      get: function get() {
        return generateChildren(instance.$children);
      }
    },
    $constants: {
      get: function get() {
        return instance._constants;
      }
    },
    $emit: {
      get: function get() {
        return customEmit(instance, instance.$emit);
      }
    },
    $el: {
      get: function get() {
        return instance.$el;
      }
    },
    $listeners: {
      get: function get() {
        return instance.$listeners;
      }
    },
    $mode: {
      get: function get() {
        return instance._tiny_mode;
      }
    },
    $nextTick: {
      get: function get() {
        return hooks.nextTick;
      }
    },
    $off: {
      get: function get() {
        return instance.$off.bind(instance);
      }
    },
    $on: {
      get: function get() {
        return instance.$on.bind(instance);
      }
    },
    $once: {
      get: function get() {
        return instance.$once.bind(instance);
      }
    },
    $options: {
      get: function get() {
        return {
          componentName: instance.$options.componentName
        };
      }
    },
    $parent: {
      get: function get() {
        return instance.$parent && createVm2({}, instance.$parent);
      }
    },
    $refs: {
      get: function get() {
        return instance.$refs;
      }
    },
    $renderless: {
      get: function get() {
        return instance.tiny_renderless;
      }
    },
    $scopedSlots: {
      get: function get() {
        return instance.$scopedSlots;
      }
    },
    $set: {
      get: function get() {
        return instance.$set;
      }
    },
    $slots: {
      get: function get() {
        return instance.$scopedSlots;
      }
    },
    $template: {
      get: function get() {
        return instance.tiny_template;
      }
    }
  });
  return vm;
};
var tools = function tools2(context, mode) {
  var _hooks$getCurrentInst3;
  var instance = (_hooks$getCurrentInst3 = hooks.getCurrentInstance()) == null ? void 0 : _hooks$getCurrentInst3.proxy;
  var root = instance == null ? void 0 : instance.$root;
  var _useRouter = useRouter(instance), route = _useRouter.route, router = _useRouter.router;
  var i18n = root == null ? void 0 : root.$i18n;
  var _emitEvent = emitEvent(instance), dispatch = _emitEvent.dispatch, broadcast = _emitEvent.broadcast;
  var parentHandler = parent(instance);
  var childrenHandler = children(instance);
  var vm = createVm({}, instance, context);
  var emit = context.emit;
  var parentVm = instance.$parent ? createVm({}, instance.$parent) : null;
  var setParentAttribute = function setParentAttribute2(_ref16) {
    var name = _ref16.name, value = _ref16.value;
    instance.$parent[name] = value;
    parentVm[name] = value;
  };
  var defineInstanceProperties = function defineInstanceProperties2(props2) {
    Object.defineProperties(vm, props2);
    Object.defineProperties(instance, props2);
  };
  var defineParentInstanceProperties = function defineParentInstanceProperties2(props2) {
    parentVm && Object.defineProperties(parentVm, props2);
  };
  hooks.onBeforeMount(function() {
    return defineProperties(vm, instance, filter);
  });
  return {
    framework: "vue2",
    vm,
    emit: customEmit(context, emit),
    emitter,
    route,
    router,
    dispatch,
    broadcast,
    parentHandler,
    childrenHandler,
    refs: context.refs,
    i18n,
    slots: context.slots,
    scopedSlots: context.slots,
    attrs: context.attrs,
    parent: parentVm,
    nextTick: hooks.nextTick,
    constants: instance == null ? void 0 : instance._constants,
    mode,
    isPCMode: mode === "pc",
    isMobileMode: mode === "mobile",
    service: instance == null ? void 0 : instance.$service,
    getService: function getService() {
      return instance == null ? void 0 : instance.$getService(vm);
    },
    setParentAttribute,
    defineInstanceProperties,
    defineParentInstanceProperties
  };
};
var mapping = function mapping2(content, before, after) {
  if (typeof content[before] !== "undefined") {
    var fn = content[before];
    content[after] = function(el, binding, vnode) {
      binding.instance = vnode.context;
      fn(el, binding, vnode);
    };
    delete content[before];
  }
};
var directive = function directive2(directives) {
  for (var name in directives) {
    var content = directives[name];
    mapping(content, "beforeMount", "bind");
    mapping(content, "updated", "update");
    mapping(content, "unmounted", "unbind");
  }
  return directives;
};
var bindVnodeData = function bindVnodeData2(_ref17) {
  var props2 = _ref17.props, data = _ref17.data, name = _ref17.name, _ref17$attr = _ref17.attr, attr = _ref17$attr === void 0 ? name : _ref17$attr;
  Object.defineProperty(props2, attr, {
    get: function get() {
      return data[name];
    },
    set: function set(value) {
      return data[name] = value;
    }
  });
};
var parseVnode = function parseVnode2(vnode) {
  var props2 = {};
  var data = vnode.componentOptions && vnode.componentOptions.propsData || {};
  for (var name in data)
    bindVnodeData({
      props: props2,
      data,
      name
    });
  vnode.props = props2;
  vnode.type = {
    name: vnode.componentOptions && vnode.componentOptions.tag
  };
  return vnode;
};
var h = hooks.h;
var createComponentFn = function createComponentFn2(design2) {
  return function(_ref18) {
    var _provide;
    var component = _ref18.component, propsData = _ref18.propsData, el = _ref18.el;
    var comp = Object.assign(component, {
      provide: (_provide = {}, _provide[design2.configKey] = design2.configInstance, _provide)
    });
    return new (Vue.extend(comp))({
      propsData,
      el
    }).$mount();
  };
};
var defineComponent = hooks.defineComponent;
var isVue2 = true;
var isVue3 = false;
var stringifyCssClassObject = function stringifyCssClassObject2(cssClassObject) {
  var allCssClass = [];
  Object.keys(cssClassObject).forEach(function(cssClass) {
    return cssClassObject[cssClass] && allCssClass.push(cssClass);
  });
  return allCssClass.join(" ");
};
var stringifyCssClassArray = function stringifyCssClassArray2(cssClassArray) {
  var allCssClass = [];
  cssClassArray.forEach(function(cssClass) {
    if (typeof cssClass === "string") {
      allCssClass.push(cssClass);
    } else if (typeof cssClass === "object") {
      allCssClass.push(stringifyCssClassObject(cssClass));
    }
  });
  return allCssClass.join(" ");
};
var stringifyCssClass = function stringifyCssClass2(cssClasses) {
  if (!cssClasses || Array.isArray(cssClasses) && !cssClasses.length)
    return "";
  var allCssClass = [];
  cssClasses.forEach(function(cssClass) {
    if (cssClass) {
      if (typeof cssClass === "string") {
        allCssClass.push(cssClass);
      } else if (Array.isArray(cssClass)) {
        allCssClass.push(stringifyCssClassArray(cssClass));
      } else if (typeof cssClass === "object") {
        allCssClass.push(stringifyCssClassObject(cssClass));
      }
    }
  });
  return allCssClass.join(" ");
};
function twJoin() {
  var index2 = 0;
  var argument;
  var resolvedValue;
  var string = "";
  while (index2 < arguments.length) {
    if (argument = arguments[index2++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
function toValue(mix) {
  if (typeof mix === "string") {
    return mix;
  }
  var resolvedValue;
  var string = "";
  for (var k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function createLruCache(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: function get() {
        return void 0;
      },
      set: function set() {
      }
    };
  }
  var cacheSize = 0;
  var cache = /* @__PURE__ */ new Map();
  var previousCache = /* @__PURE__ */ new Map();
  function update(key, value) {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  }
  return {
    get: function get(key) {
      var value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set: function set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(config) {
  var classMap = createClassMap(config);
  function getClassGroupId(className) {
    var classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  }
  function getConflictingClassGroupIds(classGroupId) {
    return config.conflictingClassGroups[classGroupId] || [];
  }
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}
function getGroupRecursive(classParts, classPartObject) {
  var _classPartObject$vali;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  var currentClassPart = classParts[0];
  var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  var classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  var classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_classPartObject$vali = classPartObject.validators.find(function(_ref) {
    var validator = _ref.validator;
    return validator(classRest);
  })) == null ? void 0 : _classPartObject$vali.classGroupId;
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
  if (arbitraryPropertyRegex.test(className)) {
    var arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    var property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
}
function createClassMap(config) {
  var theme = config.theme, prefix = config.prefix;
  var classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  var prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(function(_ref2) {
    var classGroupId = _ref2[0], classGroup = _ref2[1];
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach(function(classDefinition) {
    if (typeof classDefinition === "string") {
      var classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(function(_ref3) {
      var key = _ref3[0], classGroup2 = _ref3[1];
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart(classPartObject, path) {
  var currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(function(pathPart) {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(function(_ref4) {
    var classGroupId = _ref4[0], classGroup = _ref4[1];
    var prefixedClassGroup = classGroup.map(function(classDefinition) {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
          var key = _ref5[0], value = _ref5[1];
          return [prefix + key, value];
        }));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(config) {
  var separator = config.separator || ":";
  return function splitModifiers(className) {
    var bracketDepth = 0;
    var modifiers = [];
    var modifierStart = 0;
    for (var index2 = 0; index2 < className.length; index2++) {
      var _char = className[index2];
      if (bracketDepth === 0 && _char === separator[0]) {
        if (separator.length === 1 || className.slice(index2, index2 + separator.length) === separator) {
          modifiers.push(className.slice(modifierStart, index2));
          modifierStart = index2 + separator.length;
        }
      }
      if (_char === "[") {
        bracketDepth++;
      } else if (_char === "]") {
        bracketDepth--;
      }
    }
    var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    var hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName
    };
  };
}
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  var sortedModifiers = [];
  var unsortedModifiers = [];
  modifiers.forEach(function(modifier) {
    var isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([modifier]));
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
  return sortedModifiers;
}
function createConfigUtils(config) {
  return _extends({
    cache: createLruCache(config.cacheSize),
    splitModifiers: createSplitModifiers(config)
  }, createClassUtils(config));
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
  var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
  var classGroupsInConflict = /* @__PURE__ */ new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX).map(function(originalClassName) {
    var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName;
    var classGroupId = getClassGroupId(baseClassName);
    if (!classGroupId) {
      return {
        isTailwindClass: false,
        originalClassName
      };
    }
    var variantModifier = sortModifiers(modifiers).join(":");
    var modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    return {
      isTailwindClass: true,
      modifierId,
      classGroupId,
      originalClassName
    };
  }).reverse().filter(function(parsed) {
    if (!parsed.isTailwindClass) {
      return true;
    }
    var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId;
    var classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId).forEach(function(group) {
      return classGroupsInConflict.add(modifierId + group);
    });
    return true;
  }).reverse().map(function(parsed) {
    return parsed.originalClassName;
  }).join(" ");
}
function createTailwindMerge() {
  for (var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++) {
    createConfig[_key] = arguments[_key];
  }
  var configUtils;
  var cacheGet;
  var cacheSet;
  var functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
    var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
      return createConfigCurrent(previousConfig);
    }, firstCreateConfig());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    var cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    var result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
function fromTheme(key) {
  var themeGetter = function themeGetter2(theme) {
    return theme[key] || [];
  };
  themeGetter.isThemeGetter = true;
  return themeGetter;
}
var arbitraryValueRegex = /^\[(.+)\]$/;
var fractionRegex = /^\d+\/\d+$/;
var stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
var tshirtUnitRegex = /^(\d+)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh)/;
var shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(classPart) {
  return !Number.isNaN(Number(classPart)) || stringLengths.has(classPart) || fractionRegex.test(classPart) || isArbitraryLength(classPart);
}
function isArbitraryLength(classPart) {
  var _arbitraryValueRegex$;
  var arbitraryValue = (_arbitraryValueRegex$ = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$[1];
  if (arbitraryValue) {
    return arbitraryValue.startsWith("length:") || lengthUnitRegex.test(arbitraryValue);
  }
  return false;
}
function isArbitrarySize(classPart) {
  var _arbitraryValueRegex$2;
  var arbitraryValue = (_arbitraryValueRegex$2 = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$2[1];
  return arbitraryValue ? arbitraryValue.startsWith("size:") : false;
}
function isArbitraryPosition(classPart) {
  var _arbitraryValueRegex$3;
  var arbitraryValue = (_arbitraryValueRegex$3 = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$3[1];
  return arbitraryValue ? arbitraryValue.startsWith("position:") : false;
}
function isArbitraryUrl(classPart) {
  var _arbitraryValueRegex$4;
  var arbitraryValue = (_arbitraryValueRegex$4 = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$4[1];
  return arbitraryValue ? arbitraryValue.startsWith("url(") || arbitraryValue.startsWith("url:") : false;
}
function isArbitraryNumber(classPart) {
  var _arbitraryValueRegex$5;
  var arbitraryValue = (_arbitraryValueRegex$5 = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$5[1];
  return arbitraryValue ? !Number.isNaN(Number(arbitraryValue)) || arbitraryValue.startsWith("number:") : false;
}
function isInteger(classPart) {
  var _arbitraryValueRegex$6;
  var arbitraryValue = (_arbitraryValueRegex$6 = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$6[1];
  if (arbitraryValue) {
    return Number.isInteger(Number(arbitraryValue));
  }
  return Number.isInteger(Number(classPart));
}
function isArbitraryValue(classPart) {
  return arbitraryValueRegex.test(classPart);
}
function isAny() {
  return true;
}
function isTshirtSize(classPart) {
  return tshirtUnitRegex.test(classPart);
}
function isArbitraryShadow(classPart) {
  var _arbitraryValueRegex$7;
  var arbitraryValue = (_arbitraryValueRegex$7 = arbitraryValueRegex.exec(classPart)) == null ? void 0 : _arbitraryValueRegex$7[1];
  if (arbitraryValue) {
    return shadowRegex.test(arbitraryValue);
  }
  return false;
}
function getDefaultConfig() {
  var colors = fromTheme("colors");
  var spacing = fromTheme("spacing");
  var blur = fromTheme("blur");
  var brightness = fromTheme("brightness");
  var borderColor = fromTheme("borderColor");
  var borderRadius = fromTheme("borderRadius");
  var borderSpacing = fromTheme("borderSpacing");
  var borderWidth = fromTheme("borderWidth");
  var contrast = fromTheme("contrast");
  var grayscale = fromTheme("grayscale");
  var hueRotate = fromTheme("hueRotate");
  var invert = fromTheme("invert");
  var gap = fromTheme("gap");
  var gradientColorStops = fromTheme("gradientColorStops");
  var inset = fromTheme("inset");
  var margin = fromTheme("margin");
  var opacity = fromTheme("opacity");
  var padding = fromTheme("padding");
  var saturate = fromTheme("saturate");
  var scale = fromTheme("scale");
  var sepia = fromTheme("sepia");
  var skew = fromTheme("skew");
  var space = fromTheme("space");
  var translate = fromTheme("translate");
  var getOverscroll = function getOverscroll2() {
    return ["auto", "contain", "none"];
  };
  var getOverflow = function getOverflow2() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  };
  var getSpacingWithAuto = function getSpacingWithAuto2() {
    return ["auto", spacing];
  };
  var getLengthWithEmpty = function getLengthWithEmpty2() {
    return ["", isLength];
  };
  var getIntegerWithAuto = function getIntegerWithAuto2() {
    return ["auto", isInteger];
  };
  var getPositions = function getPositions2() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  };
  var getLineStyles = function getLineStyles2() {
    return ["solid", "dashed", "dotted", "double", "none"];
  };
  var getBlendModes = function getBlendModes2() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  };
  var getAlign = function getAlign2() {
    return ["start", "end", "center", "between", "around", "evenly"];
  };
  var getZeroAndEmpty = function getZeroAndEmpty2() {
    return ["", "0", isArbitraryValue];
  };
  var getBreaks = function getBreaks2() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ["none", "", isTshirtSize, isArbitraryLength],
      brightness: [isInteger],
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryLength],
      borderSpacing: [spacing],
      borderWidth: getLengthWithEmpty(),
      contrast: [isInteger],
      grayscale: getZeroAndEmpty(),
      hueRotate: [isInteger],
      invert: getZeroAndEmpty(),
      gap: [spacing],
      gradientColorStops: [colors],
      inset: getSpacingWithAuto(),
      margin: getSpacingWithAuto(),
      opacity: [isInteger],
      padding: [spacing],
      saturate: [isInteger],
      scale: [isInteger],
      sepia: getZeroAndEmpty(),
      skew: [isInteger, isArbitraryValue],
      space: [spacing],
      translate: [spacing]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      "float": [{
        "float": ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(getPositions(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [spacing]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [isInteger]
        }]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getIntegerWithAuto()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getIntegerWithAuto()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getIntegerWithAuto()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getIntegerWithAuto()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: getAlign()
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: [].concat(getAlign(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(getAlign(), ["baseline", "stretch"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryLength]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [spacing, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [spacing, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryLength]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(getLineStyles(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [spacing]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryLength]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      "break": [{
        "break": ["normal", "words", "all", "keep"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(getPositions(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(getLineStyles(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(getLineStyles())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmpty()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Beldn Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": getBlendModes()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isInteger]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isInteger]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [spacing]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [spacing]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [spacing]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [spacing]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [spacing]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [spacing]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [spacing]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [spacing]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [spacing]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [spacing]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [spacing]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [spacing]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [spacing]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [spacing]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      "col-start-end": ["col-start", "col-end"],
      "row-start-end": ["row-start", "row-end"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    }
  };
}
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
var version = "2.10.0";
var $prefix = "Tiny";
var $props = {
  "tiny_mode": String,
  "tiny_mode_root": Boolean,
  "tiny_template": [Function, Object],
  "tiny_renderless": Function,
  "tiny_theme": String,
  "tiny_chart_theme": Object
};
var props = ["tiny_mode", "tiny_mode_root", "tiny_template", "tiny_renderless", "_constants", "tiny_theme", "tiny_chart_theme"];
var resolveMode = function resolveMode2(props2, context) {
  var isRightMode = function isRightMode2(mode) {
    return ~["pc", "mobile", "mobile-first"].indexOf(mode);
  };
  var config = rootConfig();
  var tinyModeProp = typeof props2.tiny_mode === "string" ? props2.tiny_mode : null;
  var tinyModeInject = hooks.inject("TinyMode", null);
  var tinyModeGlobal = config.tiny_mode && config.tiny_mode.value;
  if (!isRightMode(tinyModeProp))
    tinyModeProp = null;
  if (!isRightMode(tinyModeInject))
    tinyModeInject = null;
  if (!isRightMode(tinyModeGlobal))
    tinyModeGlobal = null;
  var tinyMode = tinyModeProp || tinyModeInject || tinyModeGlobal || "pc";
  if (props2.tiny_mode_root) {
    hooks.provide("TinyMode", tinyMode);
  }
  var instance = hooks.getCurrentInstance();
  {
    instance = instance.proxy;
  }
  Object.defineProperty(instance, "_tiny_mode", {
    value: tinyMode
  });
  return tinyMode;
};
var resolveTheme = function resolveTheme2(_ref19) {
  var props2 = _ref19.props, context = _ref19.context, utils = _ref19.utils;
  var isRightTheme = function isRightTheme2(theme) {
    return ~["tiny", "saas"].indexOf(theme);
  };
  var config = rootConfig();
  var tinyThemeProp = typeof props2.tiny_theme === "string" ? props2.tiny_theme : null;
  var tinyThemeInject = hooks.inject("TinyTheme", null);
  var tinyThemeGlobal = config.tiny_theme && config.tiny_theme.value;
  if (!isRightTheme(tinyThemeProp))
    tinyThemeProp = null;
  if (!isRightTheme(tinyThemeInject))
    tinyThemeInject = null;
  if (!isRightTheme(tinyThemeGlobal))
    tinyThemeGlobal = null;
  var tinyTheme = tinyThemeProp || tinyThemeInject || tinyThemeGlobal || "tiny";
  return utils.vm.theme = tinyTheme;
};
var resolveChartTheme = function resolveChartTheme2(_ref20) {
  var props2 = _ref20.props, context = _ref20.context, utils = _ref20.utils;
  var config = rootConfig();
  var tinyChartProp = typeof props2.tiny_chart_theme === "object" ? props2.tiny_chart_theme : null;
  var tinyChartInject = hooks.inject("TinyChartTheme", null);
  var tinyChartGlobal = config.tiny_chart_theme && config.tiny_chart_theme.value;
  var tinyChartTheme = tinyChartProp || tinyChartInject || tinyChartGlobal || null;
  return utils.vm.chart_theme = tinyChartTheme;
};
var $setup = function $setup2(_ref21) {
  var props2 = _ref21.props, context = _ref21.context, template = _ref21.template, _ref21$extend = _ref21.extend, extend = _ref21$extend === void 0 ? {} : _ref21$extend;
  var view = hooks.computed(function() {
    if (typeof props2.tiny_template !== "undefined")
      return props2.tiny_template;
    var component = template(resolveMode(props2), props2);
    return typeof component === "function" ? defineAsyncComponent(component) : component;
  });
  initComponent();
  return renderComponent({
    view,
    props: props2,
    context,
    extend
  });
};
var mergeClass = function mergeClass2() {
  for (var _len3 = arguments.length, cssClasses = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    cssClasses[_key3] = arguments[_key3];
  }
  return twMerge(stringifyCssClass(cssClasses));
};
var design = {
  configKey: Symbol("designConfigKey"),
  configInstance: null
};
var provideDesignConfig = function provideDesignConfig2(designConfig) {
  if (Object.keys(designConfig).length) {
    hooks.provide(design.configKey, designConfig);
    design.configInstance = designConfig;
  }
};
var createComponent = createComponentFn(design);
var setup = function setup2(_ref22) {
  var _globalDesignConfig$c;
  var props2 = _ref22.props, context = _ref22.context, renderless = _ref22.renderless, api = _ref22.api, _ref22$extendOptions = _ref22.extendOptions, extendOptions = _ref22$extendOptions === void 0 ? {} : _ref22$extendOptions, _ref22$mono = _ref22.mono, mono = _ref22$mono === void 0 ? false : _ref22$mono, _ref22$classes = _ref22.classes, classes = _ref22$classes === void 0 ? {} : _ref22$classes;
  var render = typeof props2.tiny_renderless === "function" ? props2.tiny_renderless : renderless;
  var globalDesignConfig = hooks.inject(design.configKey, {});
  var designConfig = globalDesignConfig == null ? void 0 : (_globalDesignConfig$c = globalDesignConfig.components) == null ? void 0 : _globalDesignConfig$c[getComponentName().replace($prefix, "")];
  var utils = _extends2({
    $prefix,
    t
  }, tools(context, resolveMode(props2)), {
    mergeClass,
    designConfig,
    globalDesignConfig
  });
  resolveTheme({
    props: props2,
    context,
    utils
  });
  resolveChartTheme({
    props: props2,
    context,
    utils
  });
  var sdk = render(props2, hooks, utils, extendOptions);
  if (typeof (designConfig == null ? void 0 : designConfig.renderless) === "function") {
    Object.assign(sdk, designConfig.renderless(props2, hooks, utils, sdk));
  }
  var attrs = {
    t,
    vm: utils.vm,
    f: bindFilter,
    a: filterAttrs,
    d: utils.defineInstanceProperties,
    dp: utils.defineParentInstanceProperties,
    gcls: function gcls(key) {
      return getElementCssClass(classes, key);
    },
    m: mergeClass
  };
  attrs.d({
    slots: {
      get: function get() {
        return utils.vm.$slots;
      }
    },
    scopedSlots: {
      get: function get() {
        return utils.vm.$scopedSlots;
      }
    }
  });
  attrs.dp({
    slots: {
      get: function get() {
        return utils.parent.$slots;
      }
    },
    scopedSlots: {
      get: function get() {
        return utils.parent.$scopedSlots;
      }
    }
  });
  initComponent();
  Array.isArray(api) && api.forEach(function(name) {
    var value = sdk[name];
    if (typeof value !== "undefined") {
      attrs[name] = value;
      if (!mono) {
        utils.setParentAttribute({
          name,
          value
        });
      }
    }
  });
  return attrs;
};
var svg = function svg2(_ref23) {
  var _ref23$name = _ref23.name, name = _ref23$name === void 0 ? "Icon" : _ref23$name, component = _ref23.component;
  return function(propData) {
    return markRaw(defineComponent({
      name: $prefix + name,
      setup: function setup3(props2, context) {
        var _ref24 = context.attrs || {}, fill = _ref24.fill, width = _ref24.width, height = _ref24.height, customClass = _ref24["custom-class"];
        var mergeProps = Object.assign({}, props2, propData || null);
        var mode = resolveMode(mergeProps);
        var isMobileFirst = mode === "mobile-first";
        var tinyTag = {
          "data-tag": isMobileFirst ? "tiny-svg" : null
        };
        var attrs = {
          attrs: tinyTag
        };
        var className = isMobileFirst ? mergeClass("h-4 w-4 inline-block", customClass || "", mergeProps.class || "") : "tiny-svg";
        var extend = Object.assign({
          style: {
            fill,
            width,
            height
          },
          class: className,
          isSvg: true
        }, attrs);
        {
          extend.nativeOn = context.listeners;
        }
        return renderComponent({
          component,
          props: mergeProps,
          context,
          extend
        });
      }
    }));
  };
};
var filterAttrs = function filterAttrs2(attrs, filters, include) {
  var props2 = {};
  var _loop2 = function _loop22(name2) {
    var find = filters.some(function(r) {
      return new RegExp(r).test(name2);
    });
    if (include && find || !include && !find) {
      props2[name2] = attrs[name2];
    }
  };
  for (var name in attrs) {
    _loop2(name);
  }
  return props2;
};
var setupComponent = {};
var initComponent = function initComponent2() {
  for (var name in setupComponent) {
    var component = setupComponent[name];
    if (typeof component.install === "function") {
      component.install(appContext());
    }
    if (typeof component.init === "function") {
      component.init(appProperties());
    }
  }
  setupComponent = {};
};
var $install = function $install2(component) {
  component.install = function(Vue2) {
    Vue2.component(component.name, component);
  };
};
var index = {
  h,
  directive,
  parseVnode,
  useRouter,
  emitter,
  createComponent,
  defineAsyncComponent,
  filterAttrs,
  initComponent,
  setupComponent,
  svg,
  $prefix,
  $props,
  props,
  $setup,
  setup,
  hooks,
  getElementStatusClass,
  $install
};
export {
  $install,
  $prefix,
  $props,
  $setup,
  Teleport,
  appProperties,
  createComponent,
  index as default,
  defineAsyncComponent,
  defineComponent,
  design,
  directive,
  emitter,
  filterAttrs,
  getElementStatusClass,
  h,
  hooks,
  initComponent,
  isVue2,
  isVue3,
  mergeClass,
  parseVnode,
  props,
  provideDesignConfig,
  resolveMode,
  setup,
  setupComponent,
  svg,
  useRouter,
  version
};
